import axios from 'axios';
import { authService } from '../features/admin/login/auth.service';
import { VITE_API_BASE_URL } from '../utils/constants';

const BASE_URL = VITE_API_BASE_URL;

// Create axios instance
export const api = axios.create({
  baseURL: `${BASE_URL}/`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle 401 (Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
    }

    return Promise.reject(error);
  }
);
